import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// API
import { getAwardWinningBooks } from 'api/company';
// Components
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import ItemListAwardedBook from 'components/ItemListAwardedBook/item';
//styles
import './awardWinningBooksPage.scss';

const goUp = () => {
  window.scrollTo(0, 0);
};

const AwardWinningBooksPage = () => {
  const [awards, setAwards] = useState([]);
  const { t } = useTranslation(['home']);
  const title = t('librosPremiados', { ns: 'backoffice' });
  const [yearFilter, setYearFilter] = useState('');

  useEffect(() => {
    async function fetchAwards() {
      const params = {};
      if (yearFilter) {
        params.year = yearFilter;
      }
      const res = await getAwardWinningBooks(params);
      if (res.status === 200) {
        setAwards(res.data.results || []);
      }
    }
    fetchAwards();
  }, [yearFilter]);

  useEffect(() => {
    goUp();
  }, []);

  const handleYearChange = (e) => {
    setYearFilter(e.target.value);
  };

  return (
    <Container fluid className="margin-top-md px-4 d-flex mainDiv">
      <Head title={title} noIndex={true} />
      <Row className="awards">
        <Col lg={12}>
          <TitleWithLine text={title} />
          <Form.Select className="custom-select-responsive mb-5" value={yearFilter} onChange={handleYearChange}>
            <option value="">{t('filterByYear', { ns: 'backoffice' })}</option>
            {[...Array(10)].map((_, i) => {
              const year = new Date().getFullYear() - i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        {awards.length > 0 ? (
          awards.map((award) => (
            <Col key={award.id} lg={2} className="margin-md">
              <ItemListAwardedBook award={award} />
            </Col>
          ))
        ) : (
          <Col lg={12} className="text-center mt-4">
            <h3 className="text-muted">{t('thereAreNoBooks', { ns: 'backoffice' })}</h3>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default AwardWinningBooksPage;